import { Component, EventEmitter, Inject, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SETTINGS_SERVICE } from '../../../common/constants/injection-tokens';
import { BundleType } from '../../../common/models/enums/bundle-type.enum';
import { CourseCardImageRatioEnum } from '../../../common/models/enums/course-card-image-ratio.enum';
import { FieldName } from '../../../common/models/enums/field-name.enum';
import { LeaderboardTypeEnum } from '../../../common/models/enums/settings-leaderboard-type.enum';
import { BaseSettingsGetService } from '../../../common/services/base-settings.service';
import { SettingsModel } from '../../../common/models/settings.model';
import { startWith } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'lib-base-card',
    template: '',
    styles: [''],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BaseCardComponent implements OnInit {

  @Input() data: any;
  @Input() showType = false;
  @Input() set settingsForm(data: FormGroup) {
    if (!data) {
      return;
    }
    
    data.valueChanges
      .pipe(
        startWith(data.value)
      )
      .subscribe(settings => {
        this._settings = data.getRawValue();
        this.setSettings(settings);
      });
  }
  public get settings(): SettingsModel {
    return this._settings;
  }

  @Output() cardClick: EventEmitter<Event> = new EventEmitter();

  public certificationsTitle: string[];
  public achievementsTitle: string[];
  public selectiveLockingItems: string[];
  public hideProgress: boolean;
  public courseImageRatio: CourseCardImageRatioEnum = CourseCardImageRatioEnum.RATIO_16_9;
  public skipModule = false;
  public cardsSettings: any;
  public leaderboardEnabled = false;
  public certificatesEnabled = false;
  public achievementsEnabled = false;

  public readonly fieldNames: typeof FieldName = FieldName;
  public readonly bundleTypes: typeof BundleType = BundleType;

  private _settings: SettingsModel;

  constructor(
    @Inject(SETTINGS_SERVICE) private readonly settingsService: BaseSettingsGetService,
  ) { }

  ngOnInit(): void {
    this.certificationsTitle = this.data?.certifications?.map(item => item.title).join(', ');
    this.selectiveLockingItems = this.data?.selectiveLockingItems?.map(item => item.title).join(', ');
    this.achievementsTitle = this.data?.achievements?.map(item => item.title).join(', ');

    if (!this.settings) {
      this.settingsService.getSettings().subscribe(settings => {
        this.setSettings(settings);
      })
    }
  }

  private setSettings(settings: SettingsModel): void {
    this.cardsSettings = settings.layout.cards;
    this.hideProgress = this.data?.isLocked || !settings?.layout?.cards?.[this.data.bundle]?.progress?.visible;
    this.courseImageRatio = settings.course?.cardImageRatio;
    this.skipModule = settings.system.skip_module;
    this.leaderboardEnabled = settings.features?.leaderboard;
    this.achievementsEnabled = settings.features?.achievements;
    this.certificatesEnabled = settings.features?.certificates;
  }
}
